import { render, staticRenderFns } from "./SignUpThanks.vue?vue&type=template&id=87ae8da6&"
import script from "./SignUpThanks.vue?vue&type=script&lang=js&"
export * from "./SignUpThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports